import React from 'react';
import { Box} from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Newpagination from '../../Components/Pagination/pagination.tsx';

interface VehiclesPlatformViewProps {
    rows: any[];
    columns: GridColDef[];
    companyOptions: { id: string, label: string }[];
    selectedCompany: string;
    handleCompanyChange: (e: any) => void;
    showEntries: { id: string, label: string }[];
    pageSize: number;
    updateField: (e: any) => void;
    handleAddVehicle: () => void;
    page: number;
    activeTotalRecords: number;
    handlePageClick: (e: any, page: number) => void;
}

const VehiclesPlatformView: React.FC<VehiclesPlatformViewProps> = ({
    rows, columns, companyOptions, selectedCompany, handleCompanyChange,
    showEntries, pageSize, updateField, handleAddVehicle,
    page, activeTotalRecords, handlePageClick
}) => {
    return (
        <Box >
  

            <Box className="table-container custom-data-grid" >
                <DataGrid
                    rows={rows}
                    columns={columns}
                    sx={{ flex: 1, '& .MuiDataGrid-cell:focus': { outline: 'none' } }}
                    getRowHeight={() => 'auto'}
                    disableRowSelectionOnClick
                    disableColumnResize
                    hideFooterPagination
                />
            </Box>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                <Newpagination 
                    rows={activeTotalRecords} 
                    pageSize={pageSize} 
                    page={page} 
                    handlePageChange={handlePageClick} 
                />
            </div>

        </Box>
    );
};

export default VehiclesPlatformView;